import React from 'react';

import { DateFormat, formatDateWithYear } from '@lyearn/core/utils/date/formatDate';
import { getFormattedPercentage } from '@lyearn/core/utils/number/getFormattedPercentage';
import { useTranslation } from '@lyearn/i18n';
import { BaseButton, Box, CircularProgress, Stack, Typography } from '@lyearn/ui';
import { QuizResultEnum } from '@/types/schema';

import { AttemptHistoryItemProps } from './types';

const AttemptHistoryItem: React.FC<AttemptHistoryItemProps> = (props) => {
  const { attempt, index, maxScore, onClick } = props;
  const { score, result, updatedAt } = attempt;
  const { t } = useTranslation();

  const scorePercentage = ((score || 0) * 100) / maxScore;
  const isPassed = result === QuizResultEnum.Pass;
  const title = formatDateWithYear(updatedAt!, DateFormat.DateTime);

  return (
    <BaseButton className="m-0 w-full p-0" onClick={onClick}>
      <Stack
        alignItems="center"
        className="flex-1 cursor-pointer py-16 pe-12 ps-16"
        justifyContent="between">
        <Stack className="flex-start" direction="col" gapY={4}>
          <Typography color="text-text-primary" variant="body-short-01">
            {title}
          </Typography>
          <Typography className="me-auto" color="text-text-secondary" variant="body-short-02">
            {t('QuizPlayer:Attempt', { count: index + 1 })}
          </Typography>
        </Stack>
        <Stack alignItems="center" gapX={8}>
          <Box className="relative h-20 w-20">
            <CircularProgress
              color="success"
              overrides={{
                progressColor: isPassed ? undefined : 'text-icon-error',
              }}
              size="x-small"
              value={scorePercentage}
            />
          </Box>
          <Typography className="native:ms-6" color="text-text-primary" variant="body-short-01">
            {getFormattedPercentage(scorePercentage)}
          </Typography>
        </Stack>
      </Stack>
    </BaseButton>
  );
};

export default AttemptHistoryItem;
